import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const ItemCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [name, setName] = useState("");
    const [code, setCode] = useState("");
    const [Opening, setOpening] = useState("");
    const [isg, setISG] = useState("");
    const [purchaseRate, setPurchaseRate] = useState("0");
    const [mrp, setMRP] = useState("0");
    const [saleprice, setSalePrice] = useState("0");
    const [hsncode, setHSNCode] = useState("");
    const [gstRate, setGSTRate] = useState("0");
    const [discountPercentage, setDiscountPercentage] = useState("0");

    const [selectedStyle, setSelectedStyle] = useState("");
    const [selectedBrand, setSelectedBrand] = useState("");

    const [dropdownStyleOptions, setDropdownStyleOptions] = useState([]);
    const [dropdownBrandOptions, setDropdownBrandOptions] = useState([]);

    // Fetch HSN and GST when style changes
    useEffect(() => {
        if (selectedStyle) {
            fetchStyleItemDetails(selectedStyle);
        }
    }, [selectedStyle]);

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    const clearForm = () => {
        setName("");
        setCode("");
        setPurchaseRate("");
        setMRP("");
        setSalePrice("");
        setHSNCode("");
        setGSTRate("");
        setDiscountPercentage("");
        setOpening("0");
        setSelectedStyle("");
        setSelectedPGStyle("");
        setSelectedBrand("");
    };

    useEffect(() => {
        fetchDropdownStyleOptions();
        fetchDropdownBrandOptions();
    }, []);

    const fetchDropdownStyleOptions = () => {
        fetchData('ItemApi', `/Style/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownStyleOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Style dropdown options:', error);
            });
    };


    const fetchDropdownBrandOptions = () => {
        fetchData('ItemApi', `/Brand/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownBrandOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Pg Style dropdown options:', error);
            });
    };

    const fetchStyleItemDetails = (styleId) => {
        fetchData('ItemApi', `/GetItemByStyleId/${styleId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                if (data) {
                    // Data is a single object, not an array
                    if (data.HSNCode) {
                        setHSNCode(data.HSNCode);
                    }
                    if (data.GSTRate !== undefined && data.GSTRate !== null) {
                        setGSTRate(data.GSTRate.toString());
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching item details by style:', error);
            });
    };

    const submitData = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        if (!name) { // Check if the Style is selected
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Code: code,
            Name: name,
            PurchaseRate: purchaseRate,
            OpeningStock: Opening,
            MRP: mrp,
            SalePrice: saleprice,
            HSNCode: hsncode,
            GSTRate: gstRate,
            DiscountPercentage: discountPercentage,
            StyleId: selectedStyle,
            BrandId: selectedBrand,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('ItemApi', CreateData, token)
            .then((response) => {
                console.log('Item Created success:', response);
                setSuccessMessage("Item Created successfully!");
                setErrorMessage("");
                history.push('/ItemIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Group Create error:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item Create</h6>

                        <Button
                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <CheckCircleOutlineIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                        </Button>
                        <Button
                            component={Link}
                            to="/ItemIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }}
                        >
                            <ArrowCircleLeftIcon style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }} /> BACK TO LIST
                        </Button>

                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}
                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Item Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Name"
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Item Code
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                type="text"
                                placeholder="Enter Code"
                                style={{ height: '35px' }}
                            />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex">

                        <div className="w-2/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Style
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                className={`custom-select ${selectedStyle ? 'fade-in' : 'fade-in'}`}
                                value={selectedStyle}
                                onChange={(e) => setSelectedStyle(e.target.value)}
                                style={{ height: '35px' }}
                            >
                                <option value="">Select Style</option>
                                {dropdownStyleOptions.map((Style) => (
                                    <option key={Style.Id} value={Style.Id}>
                                        {Style.Name}
                                    </option>
                                ))}
                            </select>

                        </div>

                        <div className="w-2/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Brand
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                className={`custom-select ${selectedBrand ? 'fade-in' : 'fade-in'}`}
                                value={selectedBrand}
                                onChange={(e) => setSelectedBrand(e.target.value)}
                                style={{ height: '35px' }}
                            >
                                <option value="">Select Brand</option>
                                {dropdownBrandOptions.map((Style) => (
                                    <option key={Style.Id} value={Style.Id}>
                                        {Style.Name}
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Purchase Rate
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={purchaseRate}
                                onChange={(e) => setPurchaseRate(e.target.value)}
                                type="text"
                                placeholder="Enter Purchase Rate"
                                style={{ textAlign: 'right', height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                MRP
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={mrp}
                                onChange={(e) => setMRP(e.target.value)}
                                type="text"
                                placeholder="Enter MRP"
                                style={{ textAlign: 'right', height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Sale Price
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={saleprice}
                                onChange={(e) => setSalePrice(e.target.value)}
                                type="text"
                                placeholder="Sale Price"
                                style={{ textAlign: 'right', height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Discount %
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={discountPercentage}
                                onChange={(e) => setDiscountPercentage(e.target.value)}
                                type="text"
                                placeholder="Enter Discount %"
                                style={{ textAlign: 'right', height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                GST Rate
                                <span className="text-red-500">*</span>
                            </label>                           

                              <select
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    name="gstRate"
                                    value={gstRate}
                                    onChange={(e) => setGSTRate(e.target.value)}
                                    style={{
                                        height: '35px',       // Adjust height
                                        fontSize: '14px',     // Font size
                                        paddingLeft: '8px',   // Optional padding
                                    }}
                                >
                                    <option value={0}>0</option>
                                    <option value={5}>5</option>
                                    <option value={18}>18</option>
                                    
                                </select>
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                HSN Code
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={hsncode}
                                onChange={(e) => setHSNCode(e.target.value)}
                                type="text"
                                placeholder="Enter HSN Code"
                                style={{ height: '35px' }}
                            />
                        </div>

                    </div>



                </form>
            </div >
        </Fragment >
    );
};

export default ItemCreate;
